import { Users } from "~/api/apiRouteTypes/UsersRoute";
import { Unwrap } from "~/api/types";
import { fetchData } from "~/utils/fetch";

export type UserAccountsResult =
  Users.GetUsersUseridAccountsControllerHandle.ResponseBody;
export type UserAccountsResultData = UserAccountsResult["data"];
export type DtoGetUserIdToEvmCompatibleAccountOutput = Unwrap<
  UserAccountsResultData["evmCompatibleAccounts"]
>;

type Props = Users.GetUsersUseridAccountsControllerHandle.RequestParams &
  Users.GetUsersUseridAccountsControllerHandle.RequestQuery;

export const getUserAccounts = ({ userId, emailAccount }: Props) =>
  fetchData<UserAccountsResult>({
    url: `/users/${userId}/accounts`,
    queries: { emailAccount },
  });
